var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4305 0.714111H0.573382C0.25731 0.714111 0.00195312 0.969468 0.00195312 1.28554V12.7141C0.00195312 13.0302 0.25731 13.2855 0.573382 13.2855H15.4305C15.7466 13.2855 16.002 13.0302 16.002 12.7141V1.28554C16.002 0.969468 15.7466 0.714111 15.4305 0.714111ZM14.7162 2.69268V11.9998H1.28767V2.69268L0.79481 2.30875L1.4966 1.40697L2.26088 2.00161H13.7448L14.5091 1.40697L15.2109 2.30875L14.7162 2.69268ZM13.7448 1.99983L8.00195 6.46411L2.2591 1.99983L1.49481 1.40518L0.793025 2.30697L1.28588 2.6909L7.38588 7.43375C7.56131 7.57004 7.77713 7.64402 7.99928 7.64402C8.22142 7.64402 8.43724 7.57004 8.61267 7.43375L14.7162 2.69268L15.2091 2.30875L14.5073 1.40697L13.7448 1.99983Z",
    fill: "#047B73"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconEmail.14dce78e.svg";
export { ForwardRef as ReactComponent };